import { Reducer } from 'redux';
import { FornecedorState, FornecedorTypes } from './types';

const INITIAL_STATE: FornecedorState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<FornecedorState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FornecedorTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FornecedorTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case FornecedorTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case FornecedorTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
